import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import Checkbox from '../Checkbox';
import { useGlobalState } from '../../stateProvider/StateProvider';
import { FormContext } from '../Form';
import Collapsible from '../../layout/Collapsable';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';

const TerminalIDsSelector = ({ ...props }) => {
    const { state: { terminals = [], }, setTerminals } = useGlobalState();
    const formName = props.name || 'terminalIds';
    const context = useContext(FormContext);
    const [state, setState] = useState(false);
    const [missing, setMissing] = useState(!context.values[formName]);
    const [hasCheckedTerminals, setHasCheckedTerminals] = useState(terminals.length > 0);
    const hasRequestedTerminals = useRef(false);

    useLayoutEffect(() => {
        if (context.values && missing) {
             context.setValues(v => ({ ...v, [formName]: [] }))
            setMissing(false)
        }
    }, [])

    useEffect(() => {
        if (context.values) {
            if (missing) { return };
            setState(context.values[formName].length === 0);
        }
    }, [context.values[formName]])

    useEffect(() => {
        if (terminals.length || hasRequestedTerminals.current) return;

        hasRequestedTerminals.current = true;
        HamQuest.get(QuestRoute.terminals.ids)
            .then(res => {
                if (!Array.isArray(res)) throw new Error('Terminal IDs response was not an array.');

                setTerminals(res.map(String));
            })
            .catch(ex => console.error('Unable to load terminal IDs:', ex))
            .finally(() => setHasCheckedTerminals(true));
    }, [setTerminals, terminals.length]);

    const toggleState = () => {
        if (state) { return } else {
            setState(!state)
            context.setValues(v => ({ ...v, [formName]: [] }))
        };
    }

    if (!terminals.length) return <span>Works at all Terminals</span>;

    return (
        <>
            <b>Terminal IDs</b>
            <Collapsible
                startState={context.values[formName]?.length > 0 ? false : true}
                label={context.values ?
                    <Checkbox
                        label='Works at all Terminals'
                        value={state}
                        onClick={toggleState}
                        readOnly
                        standalone
                    /> : null}
            >
                {terminals.map((e, i) => (
                    <Checkbox
                        key={'allowedLocations' + i}
                        name={formName}
                        label={e}
                        value={parseInt(e)}
                    />
                ))}
            </Collapsible>
        </>
    )
}

export default TerminalIDsSelector;
